module.exports = __webpack_public_path__ + "static/media/ecommThumbnail.d0767952.png";